import script from "./DataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=42917e4f&scoped=true&lang=css"
script.__scopeId = "data-v-42917e4f"

export default script